import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import VolunteerRegistrationForm from '@/components/VolunteerRegistrationForm'

export default function VolunteerRegistrationPage() {
  const [searchParams] = useSearchParams()
  const initialType = searchParams.get('type') === 'group' ? 'group' : 'individual'

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 via-white to-orange-50">
      <Toaster position="top-center" />
      <header className="bg-white/95 border-b border-pink-100 sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="font-bold text-gray-900">W.E.E. Guided Access™</Link>
          <Link to="/" className="text-sm font-semibold text-pink-700 hover:underline">Back to W.E.E.</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <div className="bg-white rounded-3xl shadow-xl border border-pink-100 overflow-hidden">
          <div className="p-6 sm:p-10 bg-gradient-to-br from-pink-600 to-pink-800 text-white">
            <p className="text-sm font-semibold uppercase tracking-wider text-pink-100">Join the W.E.E. Community</p>
            <h1 className="text-3xl sm:text-4xl font-bold mt-2">Volunteer Registration</h1>
            <p className="mt-3 text-white/90 leading-relaxed">Register as an individual or as part of a group. Your information helps W.E.E. coordinate volunteer opportunities, activities, and service hours.</p>
          </div>

          <div className="p-6 sm:p-10">
            <VolunteerRegistrationForm initialType={initialType} />
          </div>
        </div>
      </main>
    </div>
  )
}
